import { render, staticRenderFns } from "./PrintAdsBtn.vue?vue&type=template&id=7b4e8a4b&"
import script from "./PrintAdsBtn.vue?vue&type=script&lang=js&"
export * from "./PrintAdsBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports